import { update_data } from 'client/utils/changeLogColumns';
import { SofturaTable } from '../../../../CommonComponents';
import './ChangeLog.scss'
const ChangeLog = (props: any) => {
  const skipVendorDetail = props?.skipVendorDetail
  let updated_array:any=[]
  if (props.Data) {
    updated_array = update_data(props?.Data)
  }


  return <div className={`ChangeLog changelog-bulkfleetorder ${props?.activeStepper == 3 || (props?.activeStepper == 2 && !skipVendorDetail) ? 'add-margin' : ''}`}>
        <div className='softura-table pe-0'>
          {
          <div className={props.Data?.length != 0 ? 'softura-table pb-3 pe-0' : 'softura-table paginationNav'}>
            <SofturaTable
              data={updated_array}
              columns={props.ApproverColumns}
              sort={true}
              defaultPageSize={10}
              pageSizes={[10,20,50]}
              globalSearch={false}
             data-attribute="ChangeLog_Default_Grid_2" />
          </div>
          }
        </div>
</div>

}
export default ChangeLog